interface LinkifyProps {
  text: string
  className?: string
}

/**
 * Component that converts URLs in text to clickable links
 * Preserves whitespace and line breaks
 */
export function Linkify({ text, className }: LinkifyProps) {
  // URL regex pattern - matches http:// and https:// URLs
  const urlPattern = /(https?:\/\/[^\s]+)/g

  // Split text by URLs and create clickable links
  const parts = text.split(urlPattern)

  return (
    <p className={className}>
      {parts.map((part, index) => {
        if (part.match(urlPattern)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800 break-all"
            >
              {part}
            </a>
          )
        }
        return <span key={index}>{part}</span>
      })}
    </p>
  )
}
